import { render, staticRenderFns } from "./MediaGalleryDialog.vue?vue&type=template&id=f9626496"
import script from "./MediaGalleryDialog.vue?vue&type=script&lang=ts"
export * from "./MediaGalleryDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports